import { GetServerSidePropsContext } from 'next';
import { getSession } from '../../providers/auth0';
import ContentfulProvider from '../../providers/contentful';
import { shopNowButtonQuery } from '.';
import { arrayToObject } from '../../utils/array-to-object';
import {
  CTA_LABELS,
  ShopNowButtonHandlerProperties,
  ShopNowButtonContentfulResponse,
} from './shop-now-button.types';
import { getCollinsonUser } from '../../providers/collinson/collinson.utils';

export const shopNowButtonHandler = async ({
  req,
  res,
}: GetServerSidePropsContext): Promise<ShopNowButtonHandlerProperties> => {
  const { opco } = req;
  const contentfulRequest = new ContentfulProvider(
    opco,
  ).makeContentfulRequest<ShopNowButtonContentfulResponse>({
    query: shopNowButtonQuery,
  });
  const session = await getSession({ opco, requestResponse: [req, res] });

  const authUser = session?.user ? await getCollinsonUser(session, opco) : null;

  const contentfulResponse = await contentfulRequest;
  const content = arrayToObject(
    contentfulResponse.data.microcopyCollection.items,
  );

  let ctaLabel = authUser
    ? content[CTA_LABELS.LOG_IN]
    : content[CTA_LABELS.LOG_OUT];

  const isUserBlocked = Boolean(authUser && authUser.blocked === '1');
  if (isUserBlocked) {
    ctaLabel = content[CTA_LABELS.BLOCKED];
  }

  return {
    isUserBlocked,
    isUserLoggedIn: Boolean(authUser?.id),
    collinsonId: authUser?.id ?? null,
    ctaLabel,
    ctaLabelTrack: content[CTA_LABELS.TRACKED],
  };
};
